import React from 'react';
import MovideskChat from './components/movidesk/movidesk-chat';

export const WebChat = () => {
    return <MovideskChat />;
};

export default WebChat;
